// What shipped, newest first: launches and the improvements a writer
// notices, one line each. Links go to docs.quarkle.ai. 2026 onward.
export const changeLogs = [
  {
    date: "2026-09-25",
    groups: [
      {
        heading: "Series",
        items: [
          "New: Series. Books in a series share one Story Atlas. Start one from the shelf or a book's Series panel. [Story Atlas](https://docs.quarkle.ai/ai/story-atlas)",
          "New: each book sees its own part of the series. The Atlas shows the shared files that appear in the open book, with a switch to the whole series, and a review where you include or leave out any file.",
          "New: Quarkle Chat reads across the series. Ask where something first came up, what happened in an earlier book, or what you planned for one of its chapters, and it looks in the other books too.",
          "New: when two books each had a file for the same character, joining them folds it into one: what holds in every book on top, and each book's own details in a section of its own.",
        ],
      },
      {
        heading: "Studio",
        items: [
          "New: switch the shelf between series (grouped, in reading order) and recent (every book, newest first).",
        ],
      },
    ],
  },
  {
    date: "2026-09-21",
    groups: [
      {
        heading: "Preferences",
        items: [
          "New: a Book scope in the preferences tab, beside Workspace. The open book's word count goal, whether it counts toward milestones, and Atlas auto-refresh (off, and Quarkle stops updating the Story Atlas and your notes for that book until you say so; the refresh button still works).",
        ],
      },
    ],
  },
  {
    date: "2026-09-19",
    groups: [
      {
        heading: "Quarkle Chat",
        items: [
          "New: Chapter read-only. A chat reads your chapter but stages no edit cards; changes come back as text for you to place. Switch it on and off in the chat tools, next to Atlas read-only.",
        ],
      },
    ],
  },
  {
    date: "2026-09-18",
    groups: [
      {
        heading: "Studio",
        items: [
          "New: keep a book out of your Milestones. Open its goal on the shelf and switch off Count toward milestones; the book keeps its own numbers, and the words-this-year, best-day and Milestones figures leave it out.",
        ],
      },
    ],
  },
  {
    date: "2026-09-17",
    groups: [
      {
        heading: "Chapters",
        items: [
          "New: the chapter list can run last to first, so the chapter you are writing sits on top. Preferences, under Appearance.",
          "Fixed: deleting a chapter renumbers the ones after it, so the number you see is the number Quarkle Chat reads.",
        ],
      },
      {
        heading: "Themes",
        items: [
          "New: Dusk (a neutral near-black) and Ember (amber on warm black, almost no blue) join Paper and Midnight. Preferences, under Appearance.",
        ],
      },
    ],
  },
  {
    date: "2026-09-16",
    groups: [
      {
        heading: "Preferences",
        items: [
          "New: every setting in one place, a settings tab in the companion panel. Theme (with a System option that follows your OS), the editor's default font, text size and line spacing, page margins, the highlight bar's Continue and inline AI, your default chat model, and the Narrator's speed.",
          "New: Send with Enter can be turned off. Enter then adds a line and Cmd or Ctrl + Enter sends.",
          "New: Auto-review. After a stretch of edits and a pause, your enabled reviewers read the new work and leave their notes. You set how many new words it waits for. Off by default.",
          "New: Auto-checkpoints can be turned off, and you set how many changed words earn a version. Manual checkpoints still work.",
        ],
      },
    ],
  },
  {
    date: "2026-09-14",
    groups: [
      {
        heading: "Read Aloud",
        items: [
          "New: the Narrator reads your chapter to you from the cursor, marking each sentence and word as it is spoken. Pause, skip a sentence, pick the language, the voice and the speed. Pro.",
        ],
      },
    ],
  },
  {
    date: "2026-09-08",
    groups: [
      {
        heading: "The Tally",
        items: [
          "New: a stats tab that measures your manuscript, counted from the chapters rather than a model's opinion: readability, dialogue, stock phrases, the words you lean on, and every chapter against published fiction.",
        ],
      },
    ],
  },
  {
    date: "2026-09-07",
    groups: [
      {
        heading: "Import",
        items: [
          "Improved: paragraphs and chapters come through cleanly from PDFs, and Word documents import too. [Import and export](https://docs.quarkle.ai/getting-started/import-and-export)",
        ],
      },
    ],
  },
  {
    date: "2026-09-04",
    groups: [
      {
        heading: "Quarkle Chat",
        items: [
          "YOLO Mode: chat edits apply themselves, undo one tap away.",
          "Atlas read-only: let a chat read the Story Atlas without writing to it.",
        ],
      },
      {
        heading: "Models",
        items: ["Gemini 3.8 Flash added."],
      },
    ],
  },
  {
    date: "2026-09-03",
    groups: [
      {
        heading: "Story Atlas",
        items: ["Redesigned: folder tabs, profile pages, portraits. [Story Atlas](https://docs.quarkle.ai/ai/story-atlas)"],
      },
      {
        heading: "Find",
        items: ["Search chapters and Atlas files as you type (Cmd/Ctrl+K)."],
      },
      {
        heading: "Drawing Room",
        items: ["Free plan: 10 pictures a day, up from 5."],
      },
    ],
  },
  {
    date: "2026-09-02",
    groups: [
      {
        heading: "Mobile",
        items: ["A full pass over the editor and the AI panel on phones."],
      },
    ],
  },
  {
    date: "2026-09-01",
    groups: [
      {
        heading: "Ghostwriter",
        items: [
          "Launched: continue writing from the chapter's end, with a direction and a length. [Ghostwriter](https://docs.quarkle.ai/editor/ghostwriter)",
        ],
      },
      {
        heading: "Models",
        items: ["GLM 5.3 Flash and Grok 4.6 added."],
      },
    ],
  },
  {
    date: "2026-08-31",
    groups: [
      {
        heading: "Edit cards",
        items: [
          "Select part of a suggested edit to accept or reject just that part. [Highlight bar](https://docs.quarkle.ai/editor/highlight-bar)",
          "Rejected edits stay rejected; Quarkle stops proposing them again.",
        ],
      },
    ],
  },
  {
    date: "2026-08-29",
    groups: [
      {
        heading: "Story Atlas",
        items: ["Drop files onto the Atlas to import them."],
      },
      {
        heading: "Drawing Room",
        items: ["Imagine: send a selected passage to the Drawing Room."],
      },
    ],
  },
  {
    date: "2026-08-28",
    groups: [
      {
        heading: "Drawing Room",
        items: [
          "Launched: cover art and character portraits drawn from your Story Atlas. [Drawing Room](https://docs.quarkle.ai/ai/drawing-room)",
        ],
      },
    ],
  },
  {
    date: "2026-08-25",
    groups: [
      {
        heading: "Quarkle Chat",
        items: ["Chapter edits arrive as accept/reject cards. [Quarkle Chat](https://docs.quarkle.ai/ai/quarkle-chat)"],
      },
    ],
  },
  {
    date: "2026-08-24",
    groups: [
      {
        heading: "Reports",
        items: [
          "Editorial reports rebuilt: a reviewer reads the whole book and writes section by section. [Reports](https://docs.quarkle.ai/ai/reports)",
        ],
      },
      {
        heading: "Referrals",
        items: ["The referral program is back. [Plans](https://docs.quarkle.ai/account/plans)"],
      },
    ],
  },
  {
    date: "2026-08-22",
    groups: [
      {
        heading: "Models",
        items: ["GLM 5.3 added."],
      },
    ],
  },
  {
    date: "2026-08-21",
    groups: [
      {
        heading: "Review Room",
        items: [
          "Reviewers read whole chapters, so long chapters get notes all the way through. [Review Room](https://docs.quarkle.ai/ai/review-room)",
        ],
      },
    ],
  },
  {
    date: "2026-08-19",
    groups: [
      {
        heading: "Review Room",
        items: ["Review a highlighted passage from the highlight bar."],
      },
    ],
  },
  {
    date: "2026-08-18",
    groups: [
      {
        heading: "Export",
        items: ["Choose which chapters go into an export."],
      },
    ],
  },
  {
    date: "2026-08-10",
    groups: [
      {
        heading: "Quarkle Chat",
        items: ["Attach images by drag and drop."],
      },
    ],
  },
  {
    date: "2026-08-05",
    groups: [
      {
        heading: "Story Atlas",
        items: ["After a chat, what you decided is distilled into your notes. [Memory](https://docs.quarkle.ai/ai/memory)"],
      },
    ],
  },
  {
    date: "2026-08-04",
    groups: [
      {
        heading: "Story Atlas",
        items: ["Chapter notes: a per-chapter place for what you intend to do next."],
      },
    ],
  },
  {
    date: "2026-08-03",
    groups: [
      {
        heading: "Milestones",
        items: ["Redesigned: streaks, goals, heatmap. [Milestones](https://docs.quarkle.ai/getting-started/milestones)"],
      },
    ],
  },
  {
    date: "2026-08-01",
    groups: [
      {
        heading: "Models",
        items: ["Claude Sonnet 5 and GPT 5.6 added."],
      },
    ],
  },
  {
    date: "2026-07-31",
    groups: [
      {
        heading: "Story Atlas",
        items: ["A revision timeline for the whole book; view and restore past versions."],
      },
      {
        heading: "Editor",
        items: ["Inline AI (Expand, Embellish, Concise, Restructure) previews as a diff before it lands."],
      },
    ],
  },
  {
    date: "2026-07-29",
    groups: [
      {
        heading: "Editor",
        items: ["Side panels stay open as minibars and expand when you need them."],
      },
    ],
  },
  {
    date: "2026-07-28",
    groups: [
      {
        heading: "Story Atlas",
        items: ["Refresh the Atlas by hand, and see which chapters are current."],
      },
      {
        heading: "Open Expression",
        items: [
          "A new safety classifier that stops over-blocking dark fiction. [Open Expression](https://docs.quarkle.ai/ai/open-expression)",
        ],
      },
    ],
  },
  {
    date: "2026-07-27",
    groups: [
      {
        heading: "Story Atlas",
        items: ["Download every note as a zip."],
      },
    ],
  },
  {
    date: "2026-07-24",
    groups: [
      {
        heading: "Version history",
        items: [
          "Compare checkpoints side by side, and restore from the diff. [Version history](https://docs.quarkle.ai/editor/version-history)",
        ],
      },
    ],
  },
  {
    date: "2026-07-23",
    groups: [
      {
        heading: "Export",
        items: [
          "Rebuilt: PDF, Word, Markdown, and plain text, with templates. [Import and export](https://docs.quarkle.ai/getting-started/import-and-export)",
        ],
      },
      {
        heading: "Editor",
        items: ["Paragraph alignment, indentation, and page margins."],
      },
    ],
  },
  {
    date: "2026-05-14",
    groups: [
      {
        heading: "Review Room",
        items: ["Review notes sit as beads in the margin."],
      },
    ],
  },
  {
    date: "2026-05-07",
    groups: [
      {
        heading: "Models",
        items: ["Kimi K2.5 added."],
      },
    ],
  },
  {
    date: "2026-04-30",
    groups: [
      {
        heading: "Quarkle Chat",
        items: ["See what Quarkle is reading while it works."],
      },
    ],
  },
  {
    date: "2026-04-29",
    groups: [
      {
        heading: "Account",
        items: ["A Usage tab and daily limits. [Usage and limits](https://docs.quarkle.ai/account/usage-and-limits)"],
      },
    ],
  },
  {
    date: "2026-04-25",
    groups: [
      {
        heading: "Mobile",
        items: ["Switch chapters from the mobile editor."],
      },
    ],
  },
  {
    date: "2026-04-24",
    groups: [
      {
        heading: "Quarkle Chat",
        items: [
          "Quarkle Chat is an agent: it reads your chapters and Atlas files as it answers. [Quarkle Chat](https://docs.quarkle.ai/ai/quarkle-chat)",
        ],
      },
    ],
  },
  {
    date: "2026-03-26",
    groups: [
      {
        heading: "Performance",
        items: ["The Studio and the editor open faster."],
      },
    ],
  },
];
